export const setsearch=(term)=>{
    return{
        type:'SET_SEARCH',
        payload:term
    }
}